export default __webpack_public_path__ + "static/media/my-profile-banner.4b54d21e.png";